import { render, staticRenderFns } from "./PlanUpgrade.vue?vue&type=template&id=0a63cc02&scoped=true"
import script from "./PlanUpgrade.vue?vue&type=script&lang=js"
export * from "./PlanUpgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a63cc02",
  null
  
)

export default component.exports